import AbortService from "@rmp/core/services/abortService";
import Breadcrumb from "@rmp/core/stores/composables/page/types/breadcrumb";
import { useAppStore } from "@rmp/core/stores/appStore";
import NotImplementedException from "@rmp/core/exceptions/notImplementedException";
import i18n from "@rmp/core/plugins/i18n/core";
import { defineStore } from "pinia";
import { watchEffect, type WatchStopHandle } from "vue";
import { PageModeType } from "@rmp/core/stores/appStore/types/pageModeType";

export interface PageState {
	initialized: boolean;
	loading: boolean;
	unwatchers: WatchStopHandle[];
	generation: number;
}


export function usePageStore(abortService: AbortService) {
	const getDefaultState = (): PageState => {
		return {
			initialized: false,
			loading: false,
			unwatchers: [],
			generation: 0
		};
	};
	
	const getters = {
		breadcrumbs() {
			return [];
		}
	};
	
	const actions = {
		async beforeInitialized(...args: any) {
			throw new NotImplementedException(i18n.t("errors.pageBeforeInitializedHookNotDefined").toString());
		},
		async initialize(...args: any) {
			// @ts-ignore
			if(this.initialized) {
				console.error(i18n.t("errors.console.storeAlreadyInitialized").toString());
			}
			
			// @ts-ignore
			this.loading = true;
			const { setBreadcrumbs, setBreadcrumbsLoading } = useAppStore();
			
			// TODO Костыль немного. Сначала смотрим есть ли геттер с хлебными крошками, если есть, отображаем loader
			// @ts-ignore
			if(this.breadcrumbs.length) {
				setBreadcrumbsLoading(true);
			} else {
				setBreadcrumbs([]);
			}
			
			abortService.initialize();
			
			// @ts-ignore
			const generation = ++this.generation;
			
			await this.beforeInitialized(...args);
			
			// @ts-ignore
			if(this.generation !== generation)
				return;
			
			const { pageMode } = useAppStore();
			if(pageMode !== PageModeType.OK)
				return;
			
			// @ts-ignore
			this.initialized = true;
			
			const unwatch = watchEffect(() => {
				// @ts-ignore
				setBreadcrumbs(this.breadcrumbs);
			});
			
			// @ts-ignore
			this.unwatchers.push(unwatch);
			
			setBreadcrumbsLoading(false);
			// @ts-ignore
			this.loading = false;
		},
		destroyBase() {
			abortService.abort();
		},
		destroy() {
			this.destroyBase();
			// @ts-ignore
			this.unwatchers.forEach(unwatch => {
				try {
					unwatch();
				} catch (ex) {
					console.error("unwatchers:", ex);
				}
			});
			// @ts-ignore
			const generation = this.generation;
			// @ts-ignore
			this.$reset();
			// @ts-ignore
			this.generation = generation + 1;
		},
		setBreadcrumbs(this: PageState, value: Breadcrumb[]) {
		}
	};
	
	return {
		actions, getters,
		getDefaultPageState: getDefaultState
	};
}

let storeComposables: ReturnType<typeof usePageStore>;
export type PageStoreDefinition =
	ReturnType<typeof defineStore<string, PageState, typeof storeComposables.getters, typeof storeComposables.actions & {
		[key: string]: any
	}>> | any;
